module.exports = __webpack_public_path__ + "img/pump-west-liquid.5be09aa5.png";